export enum Roles {
    Admin = "ADMIN",
    AdminAdvanced = "ADMIN_ADVANCED",
    Developer = "DEVELOPER",
}
